/**
 * Where a mousedown may land without clearing the grid selection (30.09.2026).
 *
 * A click outside the grid clears the selection, and an empty selection drops
 * the record (vertical) view. The find bar sits outside `.dbm-grid-wrap`, so
 * EVERY click in it — Aa, ▲/▼, ✕, even the input — cleared the selection and
 * collapsed the record view the search was running over (owner, 30.09.2026:
 * "clicking Aa drops the vertical view").
 *
 * Safe targets:
 *   .dbm-grid-wrap    the grid itself
 *   .dbm-footer-left  the selection's action bar (Delete / Cancel / Save / Copy
 *                     read the selection at click time)
 *   .dbm-find         the find bar
 *   .modal-content / .modal-backdrop  a modal over the grid (a DOM sibling)
 *   [data-keeps-selection]  a control that acts on the selection from outside
 *                     those (the query footer's Export…, which offers
 *                     "Selected rows" — its mousedown used to clear them first)
 */
const SAFE = ['.dbm-grid-wrap', '.dbm-footer-left', '.dbm-find', '.modal-content', '.modal-backdrop', '[data-keeps-selection]'];

export function isSelectionSafeTarget(target) {
  if (!target || typeof target.closest !== 'function') return false;
  return SAFE.some((sel) => target.closest(sel));
}
